// frontend/src/components/SiteVerificationMeta.jsx
// FRONTEND_CODE_VERSION = "v1.0.0"
// Optional Search Console / Bing verification via Vite env (set in Vercel or .env.local).

import React from "react";
import { Helmet } from "react-helmet-async";

export default function SiteVerificationMeta() {
  const google = import.meta.env.VITE_GOOGLE_SITE_VERIFICATION;
  const bing = import.meta.env.VITE_BING_SITE_VERIFICATION;
  if (!google && !bing) return null;
  return (
    <Helmet>
      {google ? (
        <meta name="google-site-verification" content={String(google)} />
      ) : null}
      {bing ? <meta name="msvalidate.01" content={String(bing)} /> : null}
    </Helmet>
  );
}
